export default {
	data() {
		return {
			provinceList: [],
			cityList: [],
			districtList: [],
			provinceListNew:[],
			cityListNew:[],
			districtListNew:[],
		}
	},
	created() {
		this.getTblProvince()
		this.getTblProvinceNew()
	},
	methods: {
		// 获取省份列表
		getTblProvince() {
			const url = `/autoapp-default-server-recovery/api/jd/recycle/address/listProvince`
			return this.HttpService.get(url).then(res => {
				if (res.statusCode === 200) {
					this.provinceList = res.data || []
				}
			})
		},
		// 根据省份获取城市列表
		getTblCity(provinceCode) {
			const url = `/autoapp-default-server-recovery/api/jd/recycle/address/listCityByProvinceId?provinceId=${provinceCode}`
			return this.HttpService.get(url).then(res => {
				if (res.statusCode === 200) {
					this.cityList = res.data || []
				}
			})
		},
		// 根据省市获取区域
		getTblCounty(provinceId, cityId) {
			const url = `/autoapp-default-server-recovery/api/jd/recycle/address/listByCondition`
			const params = {
				provinceId,
				cityId,
			}
			return this.HttpService.post(url, params).then(res => {
				if (res.statusCode === 200) {
					// console.log('===res===', res)
					this.districtList = res.data || []
				}
			})
		},


		// 获取省份列表
		getTblProvinceNew() {
			const url = `/autoapp-default-server-recovery/api/jd/recycle/address/listAddress`
			return this.HttpService.post(url,{}).then(res => {
				if (res.statusCode === 200) {
					this.provinceListNew = res.data || []
				}
			})
		},
		// 根据省份获取城市列表
		getTblCityNew(provinceCode) {
			const url = `/autoapp-default-server-recovery/api/jd/recycle/address/listAddress`
			return this.HttpService.post(url,{provinceId:provinceCode}).then(res => {
				if (res.statusCode === 200) {
					this.cityListNew = res.data || []
				}
			})
		},

		// 根据城市获取区县列表
		getTblCountyNew(provinceCode,cityId) {
			const url = `/autoapp-default-server-recovery/api/jd/recycle/address/listAddress`
			return this.HttpService.post(url,{provinceId:provinceCode,cityId:cityId}).then(res => {
				if (res.statusCode === 200) {
					this.districtListNew = res.data || []
				}
			})
		},
	},
}



// WEBPACK FOOTER //
// ./src/views/jdOldMachineRecycleManage/mixins/jdProvinceCity.js